import { isProductionDomain } from './utils';

/**
 * GTM (Google Tag Manager) Utilities
 *
 * Helper functions to determine when GTM should load.
 * GTM should only load on production domain (www.sibcycline.com)
 * to prevent tracking on Vercel preview deployments.
 */

/**
 * Determines if GTM should load based on production domain check.
 * Alias for isProductionDomain() for clarity in GTM context.
 *
 * @returns {boolean} True if GTM should be loaded
 */
export function shouldLoadGTM() {
  const enableLocalGTM = process.env.NEXT_PUBLIC_ENABLE_LOCAL_GTM === 'true';
  return isProductionDomain() || enableLocalGTM;
}
